var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (missing, sequence, undefined) {
// iterate sequence
;(function(){
  var $$obj = sequence;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var image = $$obj[i];

var klass = missing.indexOf(i) > -1 ? "hidden" : "";
buf.push("<div class=\"next-img-container block-sm\"><div" + (jade.cls(['block-lt','block-sm',klass + " delay-" + (i) + ""], [null,null,true])) + "><img" + (jade.attr("src", image, true, false)) + " class=\"next-img\"/></div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var image = $$obj[i];

var klass = missing.indexOf(i) > -1 ? "hidden" : "";
buf.push("<div class=\"next-img-container block-sm\"><div" + (jade.cls(['block-lt','block-sm',klass + " delay-" + (i) + ""], [null,null,true])) + "><img" + (jade.attr("src", image, true, false)) + " class=\"next-img\"/></div></div>");
    }

  }
}).call(this);
}.call(this,"missing" in locals_for_with?locals_for_with.missing:typeof missing!=="undefined"?missing:undefined,"sequence" in locals_for_with?locals_for_with.sequence:typeof sequence!=="undefined"?sequence:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}